import { REQUEST_LOGIN_CREDENTIALS } from './Base';

export const onCreateRequest = (payload, cb) => ({ payload, cb, type: REQUEST_LOGIN_CREDENTIALS.CREATE_REQUEST });
export const onCreateFailure = (errors = {}) => ({ errors, type: REQUEST_LOGIN_CREDENTIALS.CREATE_FAILURE });
export const onCreateSuccess = (payload = {}) => ({ payload, type: REQUEST_LOGIN_CREDENTIALS.CREATE_SUCCESS });